import axios from "axios";
import {getBrowserInfo} from 'utils'

export const SEND_EMAIL_REQUEST = 'SEND_EMAIL_REQUEST';
export const SEND_EMAIL_ERROR = 'SEND_EMAIL_ERROR';
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
export const SET_TOKEN = 'SET_TOKEN';

export const VERIFY_EMAIL_REQUEST = 'VERIFY_EMAIL_REQUEST';
export const VERIFY_EMAIL_VERIFIED = 'VERIFY_EMAIL_VERIFIED';
export const VERIFY_EMAIL_NOT_VERIFIED = 'VERIFY_EMAIL_NOT_VERIFIED';
export const VERIFY_EMAIL_ERROR = 'VERIFY_EMAIL_ERROR';
export const INCREASE_LOCAL_INCREMENT = 'INCREASE_LOCAL_INCREMENT';
export const SET_LOCAL_INCREMENT = 'SET_LOCAL_INCREMENT';

export const LOGIN_USER_SOCIAL = 'LOGIN_USER_SOCIAL';

export const LOGOUT = 'LOGOUT';
export const SET_ME = 'SET_ME';

export const sendEmailRequest = () => ({
    type: SEND_EMAIL_REQUEST,
    // payload: {data, resolve, reject}
});

export const sendEmailSuccess = (result, email) => ({
    type: SEND_EMAIL_SUCCESS,
    payload: result,
    email,
});

export const sendEmailError = (error) => ({
    type: SEND_EMAIL_ERROR,
    payload: error,
});


export const verifyEmailRequest = () => ({
    type: VERIFY_EMAIL_REQUEST
});

export const verifyEmailVerified = () => ({
    type: VERIFY_EMAIL_VERIFIED
});

export const verifyEmailNotVerified = () => ({
    type: VERIFY_EMAIL_NOT_VERIFIED
});

export const verifyEmailError = (error) => ({
    type: VERIFY_EMAIL_ERROR,
    payload: error,
});

export const logout = () => ({
    type: LOGOUT
});

export const increaseLocalIncrement = () => ({
    type: INCREASE_LOCAL_INCREMENT,
});

export const setLocalIncrement = (value) => ({
    type: SET_LOCAL_INCREMENT,
    value
})


export const sendVerificationRequest = () => {
    return (dispatch, getState) => {
        dispatch(verifyEmailRequest());
        axios({
            method: 'get',
            url: process.env.REACT_APP_API_BASE_URL + 'user/device/is-activated/',
            headers: {'Authorization': 'Device-Token ' + getState().auth.token}
        }).then((response) => {
            const data = response.data;
            if (data.activated === true) {
                dispatch(verifyEmailVerified());
            }
            else {
                dispatch(verifyEmailNotVerified());
            }
        }).catch((error) => {
            console.log(error);
            // dispatch(verifyEmailNotVerified());
        });
    };
};


export const retrieveMe = () => {
    return (dispatch, getState) => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_API_BASE_URL + 'user/profile/',
            headers: {'Authorization': 'Device-Token ' + getState().auth.token}
        }).then((response) => {
            dispatch({type: SET_ME, payload: response.data})
        }).catch((error) => {
            console.log(error);
        });
    }
}

export const updateUserName = (username) => {
    return (dispatch, getState) => {
        axios({
            method: 'patch',
            url: process.env.REACT_APP_API_BASE_URL + 'user/profile/',
            headers: {'Authorization': 'Device-Token ' + getState().auth.token},
            data: {name: username}
        }).then((response) => {
            dispatch(retrieveMe())
        }).catch((error) => {
            console.log(error);
        });
    }
}


export const sendSocialLoginRequest = (provider, payload) => {
    return (dispatch, getState) => {
        const browserInfo = getBrowserInfo()
        let data = {
            device_name: browserInfo['version'], device_manufacturer: browserInfo['name'], platform: 'web'
        };
        if (provider === 'facebook') {
            data['fb_token'] = payload.accessToken;
        }
        if (provider === 'google') {
            data['id_token'] = payload.tokenId;
        }
        axios({method: 'post', data, url: process.env.REACT_APP_API_BASE_URL + 'user/device/assign/' + provider + '/'}).then((response) => {
            dispatch({type: LOGIN_USER_SOCIAL, payload: response.data})
        }).catch((error) => {
            console.log(error);
        });
    }
};

// export const sendFacebookLoginRequest = retrieveRequestFactory('user/device/assign/facebook/', 'FACEBOOK_LOGIN', false, (payload) => ({
//     type: LOGIN_USER_FACEBOOK,
//     payload: payload,
// }));










// WEBPACK FOOTER //
// ./src/store/auth/actions.js